/**
 * Toggle accordion
 * @param {HTMLElement} target
 */
export function toggleSubMenu(target) {
  const parent = target.parentElement
  const modifyDiv = /** @type {HTMLElement} */ (
    parent?.querySelector('.accordion-body')
  )
  const accordionClassList = parent?.classList

  if (!modifyDiv || !accordionClassList) return

  const isOpen = accordionClassList.contains('open')

  if (!isOpen) {
    accordionClassList.add('open')
    target.setAttribute('aria-expanded', 'true')
  } else {
    accordionClassList.remove('open')
    target.setAttribute('aria-expanded', 'false')
  }
}
